import { useNotification } from "@kyvg/vue3-notification";
import { trans } from "../helpers";
const { notify } = useNotification()

// Create a new store instance.
import { defineStore } from 'pinia'

export const useOnboardStore = defineStore('onboard', {

    state: () => ({
        user: {},
        configs: false,
        php_versions: [],
        wp_versions: [],
        stack_products: [],
        default_php: null,
        default_wp: null,
        notification: {},
        launch_site_status: false,
        launch_site_message: false,
        launch_site_progress: 0,
        launch_site_detail: {},
        launch_site_custom_redirect: false,
        install_content_status: false,
        install_content_message: false,
        server_groups: [],
        site_task_id: null,
        form: {
            name: '',
            email: '',
            self_described: '',
            grc_token: "",
            configuration_id: 1,
            php_version: '',
            wp_version: '',
            is_reserved: false,
            server_group_id: '',
            stack_product_ids: [],
            terms: '',
        },
        serverErrors: [],
        onboardProcessing: false,
        subscribeFreePlan: false,
        tenant: {},
    }),
    actions: {
        async getVersions() {
            let response = await axios.get("/api/v2/versions");
            let responseData = response.data.data;
            this.wp_versions = responseData.versions
            this.default_php = responseData.default.php
            this.default_wp = responseData.default.wp
            this.server_groups = responseData.server_groups

            let wp = this.wp_versions.filter(el => el.wp == this.default_wp)
            if (wp.length) {
                wp = wp[0]
                this.form.wp_version = wp.wp
                this.form.php_version = wp.php.includes(this.default_php) ? this.default_php : wp.php[0]
            } else {
                this.form.php_version = this.default_php
                this.form.wp_version = this.default_wp
            }
            this.form.server_group_id = this.serverGroups ? this.serverGroups[0].group_id : ''

        },
        getOnboardConfigs() {
            axios
                .get("/api/v1/onboard-configs")
                .then((response) => {
                    this.configs = response.data.data.configs
                    this.stack_products = response.data.data.stack_products
                    this.form.stack_product_ids = this.stack_products.filter(i => i?.is_popular).map((x) => x.id)
                })
                .catch(function (error) {
                });
        },
        subscribeSiteInstallationProgressEvent() {
            let id = this.site_task_id
            window.Echo.channel(`site.installation.progress.${id}`)
                .listen('SiteInstallationProgress', (e) => {
                    let progress = e.hasOwnProperty('percentage_complete') ? e.percentage_complete : 0
                    this.launch_site_progress = progress
                    this.launch_site_message = { heading: trans('installation_in_progress'), subHeading: trans('installing_wordpress') }

                    if (progress == 100) {
                        let uri =
                            window.location.search.substring(1);
                        let params = new URLSearchParams(uri);

                        if (
                            (params.get("plugins") || params.get("themes")) && e?.install_content_task_id
                        ) {
                            // let pluginSlugs = params.get("plugins"),
                            //     themeSlugs = params.get("themes");

                            // const useOnboardStoreObject = useOnboardStore()
                            // useOnboardStoreObject.installPluginTheme({
                            //     plugin_slugs: pluginSlugs,
                            //     theme_slugs: themeSlugs,
                            //     id: e.id
                            // });
                            this.install_content_message = "Plugin/Theme";

                            this.install_content_status = 'processing';
                            let installContentTaskID = e.install_content_task_id
                            window.Echo.channel(`site.plugin.theme.installation.progress.${installContentTaskID}`)
                                .listen('SitePluginThemeInstallationProgress', (e) => {
                                    let progress = e.hasOwnProperty('percentage_complete') ? e.percentage_complete : 0

                                    if (progress == 100) {
                                        this.install_content_status = 'completed';
                                        Echo.leave(`site.plugin.theme.installation.progress.${installContentTaskID}`);
                                    }

                                    if (e.hasOwnProperty('status') && e.status == 'error') {
                                        this.install_content_status = 'failed';
                                        Echo.leave(`site.plugin.theme.installation.progress.${installContentTaskID}`);
                                    }

                                });
                        }
                        this.site_task_id = 0
                        this.launch_site_message = {
                            heading: trans('your_new_wordpress_website_ready'),
                            subHeading: trans('wp_login_credentials')
                        }


                        this.launch_site_detail = {
                            ...this.launch_site_detail,
                            wp_username: e.username,
                            wp_password: e.password,
                        }
                        this.launch_site_status = "completed"
                        Echo.leave(`site.installation.progress.${id}`);
                        // TODO fix createMultiTabState
                        // commit("toggleRefreshTable");
                    }

                    if (e.hasOwnProperty('status') && e.status == 'error') {
                        Echo.leave(`site.installation.progress.${id}`);

                        this.site_task_id = 0
                        this.launch_site_message = {
                            heading: `Site creation has failed.`,
                            subHeading: e.hasOwnProperty('comment') ? e.comment : ''
                        }
                        this.launch_site_status = "failed"
                        // TODO fix createMultiTabState
                        // commit("toggleRefreshTable");
                    }
                });
        },
        installPluginTheme(payload) {

            let pluginSlugs = payload.plugin_slugs;
            let themeSlugs = payload.theme_slugs;
            let slugData = {}
            let initMsg = "Installing ";
            if (pluginSlugs) {
                initMsg += 'Plugin(s)'
                slugData.plugin_slugs = pluginSlugs
            }
            if (themeSlugs) {
                initMsg += pluginSlugs ? ', Theme(s)' : 'Theme(s)'
                slugData.theme_slugs = themeSlugs
            }
            this.install_content_message = initMsg
            this.install_content_status = "waiting"
            axios
                .put(
                    Object.keys(this.user).length
                        ? "/api/v2/sites/" + payload.id + "/install-content/"
                        : "/api/v2/sites/" + payload.id + "/install-content-guest/",
                    slugData
                )
                .then((response) => {
                    this.install_content_message = response.data.data.items_text
                    this.install_content_status = "processing"
                    window.Echo.channel(`site.plugin.theme.installation.progress.${response.data.data.task_id}`)
                        .listen('SitePluginThemeInstallationProgress', (e) => {
                            let progress = e.hasOwnProperty('percentage_complete') ? e.percentage_complete : 0

                            if (progress == 100) {
                                this.install_content_status = "completed"
                                Echo.leave(`site.plugin.theme.installation.progress.${response.data.data.task_id}`);
                            }

                            if (e.hasOwnProperty('status') && e.status == 'error') {
                                this.install_content_status = "failed"
                                Echo.leave(`site.plugin.theme.installation.progress.${response.data.data.task_id}`);
                            }

                        });
                })
                .then((response) => {
                    window.history.pushState(
                        {},
                        document.title,
                        window.location.pathname
                    );
                })
                .then(function (response) {
                })
                .catch(function (error) {
                    
                });
        },
        setNotification(notification) {
            if (notification && notification?.heading && notification?.subHeading && notification?.subHeading?.length > 0) {
                notify({
                    title: notification.heading,
                    text: notification.subHeading,
                    type: notification.type
                });
                this.notification = notification;
            }
        },
        setTenant(data) {
            this.tenant = data;
        },
        trackPaywallEvent(event, feature, triggerRef = '') {
            
            axios.post("/api/v2/track-paywall-event", {
                'event': event,
                'feature': feature,
                'trigger_ref': triggerRef
            })
                .then((response) => {
                })
        },
    },
    getters: {

        getDefaultWpVersion: (state) => {
            return state.default_wp;
        },
        getDefaultPHPVersion: (state) => {
            return state.default_php;
        },
        userConfigs: (state) => {
            return state.configs;
        },
        getLaunchSiteStatus: (state) => {
            return state.launch_site_status;
        },
        getLaunchSiteMessage: (state) => {
            return state.launch_site_message;
        },
        getLaunchSiteProgress: (state) => {
            return state.launch_site_progress;
        },
        getLaunchSiteCustomRedirect: (state) => {
            return state.launch_site_custom_redirect;
        },
        getLaunchSiteDetail: (state) => {
            return state.launch_site_detail;
        },
        getInstallContentStatus: (state) => {
            return state.install_content_status;
        },
        getInstallContentMessage: (state) => {
            return state.install_content_message;
        },
        getInstallContentMsg: (state) => {
            if (!state.install_content_status) {
                return false
            }
            if (state.install_content_status == 'waiting') {
                return state.install_content_message + ' will be installed.'
            } else if (state.install_content_status == 'processing') {
                return state.install_content_message + ' installation has started.'
            } else if (state.install_content_status == 'completed') {
                return state.install_content_message + ' installed.'
            } else if (state.install_content_status == 'failed') {
                return state.install_content_message + ' installation failed.'
            } else {
                return false
            }
        },
        serverGroups: (state) => {
            return state.server_groups
        },

        getSiteTaskId: (state) => {
            return state.site_task_id;
        },
        isTenantTypeInstaWP: (stage) => {
            if (!stage.tenant) {
                return false
            }
            return stage.tenant.type == 'instawp' ? true : false
        },
        isTenantTypeExternal: (stage) => {
            if (!stage.tenant) {
                return false
            }
            return stage.tenant.type == 'external' ? true : false
        },

    },
    plugins: [

    ],
    strict: process.env.NODE_ENV !== "production",
});
